const AllColor = [
    {
        name: 'Black',
        hex: '#000000',
        id: 1
    },
    {
        name: 'Brown',
        hex: '#964B00',
        id: 2
    },
    {
        name: 'Green',
        hex: '#008000',
        id: 3
    },
    {
        name: 'Off White',
        hex: '#f8f8ff',
        id: 4
    },
    {
        name: 'Purple',
        hex: '#800080',
        id: 5
    },
    {
        name: 'Red',
        hex: '#ff0000',
        id: 6
    },
    {
        name: 'White',
        hex: '#ffffff',
        id: 7
    }
]

export default AllColor;